import i18n from '@/i18n'
import { personService } from '@/services/person.service'
import { mapActions } from 'vuex'
import { SnackbarStyle } from '@/constants/constants'
import { DialogPerson } from "@/tools/dialog"
import PersonDialogDataTabComponent from './tabs/data/PersonDialogDataTabComponent.vue'
import PersonDialogAddressTabComponent from './tabs/address/PersonDialogAddressTabComponent.vue'
import PersonDialogContactTabComponent from './tabs/contact/PersonDialogContactTabComponent.vue'
import PersonDialogCommentTabComponent from './tabs/comment/PersonDialogCommentTabComponent.vue'
import PersonDialogDriverCodeTabComponent from './tabs/driver-code/PersonDialogDriverCodeTabComponent.vue'
import PersonDialogEnterpriseTabComponent from './tabs/enterprise/PersonDialogEnterpriseTabComponent.vue'
import { REGEX } from '@/constants/constants'
import moment from 'moment'
import Vue from 'vue'
import { Util } from '@colven/common-domain-lib/lib'
import { enterpriseService } from '@/services/enterprise.service'

export default {
    name: 'PersonDialogComponent',
    components: {
        PersonDialogDataTabComponent,
        PersonDialogAddressTabComponent,
        PersonDialogContactTabComponent,
        PersonDialogDriverCodeTabComponent,
        PersonDialogCommentTabComponent,
        PersonDialogEnterpriseTabComponent
    },
    props: {
        // v-model injects the object to be edited into props.value
        model: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        // tab seleccionada
        tab: null,
        // modelos de los tabs
        personDialogDataTab: {
            key: 'personDialogDataTab',
            tab: i18n.t('person.editDialog.tabs.personalInformation'),
            tooltip: i18n.t('person.editDialog.tabs.personalInformationTooltip'),
            icon: 'mdi-form-textbox',
            content: {
                _uid: 'IxzjDIe1vw',
                component: 'PersonDialogDataTabComponent',
                headline: 'PersonDialogDataTabComponent'
            },
            model: {
                firstName: null,
                lastName: null,
                cuit: null,
                dni: null,
                dateOfBirth: null,
                civilStatus: null
            },
            validForm: false
        },
        personDialogEnterpriseTab: {
            key: 'personDialogEnterpriseTab',
            tab: i18n.t('person.editDialog.tabs.enterprises'),
            tooltip: i18n.t('person.editDialog.tabs.enterprisesTooltip'),
            icon: 'mdi-shield-home',
            disabled: false,
            content: {
                _uid: 'oLkbANttlv',
                component: 'PersonDialogEnterpriseTabComponent',
                headline: 'PersonDialogEnterpriseTabComponent'
            },
            model: {
                enterprisesData: [],
                enterpriseIds: [],
            },
            validForm: false
        },
        personDialogAddressTab: {
            key: 'personDialogAddressTab',
            tab: i18n.t('person.editDialog.tabs.address'),
            tooltip: i18n.t('person.editDialog.tabs.addressTooltip'),
            icon: 'mdi-map-marker',
            content: {
                _uid: 'k0gpFhXsKb',
                component: 'PersonDialogAddressTabComponent',
                headline: 'PersonDialogAddressTabComponent'
            },
            model: {
                address: null,
                cityId: null,
                district: null,
                provinceId: null,
                countryId: null,
                zipCode: null
            },
            validForm: false
        },
        personDialogContactTab: {
            key: 'personDialogContactTab',
            tab: i18n.t('person.editDialog.tabs.contact'),
            tooltip: i18n.t('person.editDialog.tabs.contactTooltip'),
            icon: 'mdi-card-account-phone-outline',
            content: {
                _uid: 'KwHHNP7Y3c',
                component: 'PersonDialogContactTabComponent',
                headline: 'PersonDialogContactTabComponent'
            },
            model: {
                phone1: null,
                phone2: null,
                whatsapp: null,
                sms: null,
                email1: null,
                email2: null
            },
            validForm: false
        },
        personDialogDriverCodeTab: {
            key: 'personDialogDriverCodeTab',
            tab: i18n.t('person.editDialog.tabs.driverCode'),
            tooltip: i18n.t('person.editDialog.tabs.driverCodeTooltip'),
            icon: 'mdi-account-key',
            content: {
                _uid: 'fwGyDLKBWf',
                component: 'PersonDialogDriverCodeTabComponent',
                headline: 'PersonDialogDriverCodeTabComponent'
            },
            model: {
                _id: null,
                driverCode: null,
                reassignment: false,
                personIdDriverCodeUnset: null
            },
            validForm: false
        },
        personDialogCommentTab: {
            key: 'personDialogCommentTab',
            tab: i18n.t('person.editDialog.tabs.comment'),
            tooltip: i18n.t('person.editDialog.tabs.comment'),
            icon: 'mdi-form-textarea',
            content: {
                _uid: 'H3jdhS8zNM',
                component: 'PersonDialogCommentTabComponent',
                headline: 'PersonDialogCommentTabComponent'
            },
            model: {
                comment: null
            },
            validForm: false
        },
        // array donde se juntan las tabs
        tabs: [],
        // reglas de validación
        validationRules: {
            required: value => !!value || `${i18n.t('required')}`,
            driverCodeLength: value => value == null || value === '' || (value != null && value.length === 8) || `${i18n.t('error.strLength', {length: 8})}`,
            email: value => !value || REGEX.email.test(value.toString()) || `${i18n.t('error.invalidEmail')}`,
            phone: (value) => !value || REGEX.phone.test(value) || `${i18n.t('error.invalidPhone')}`,
            cuit: (value) => !value || Util.validateCuit(value.toString()) || `${i18n.t('error.invalidCUIT')}`,
            dni: (value) => !value || REGEX.dni.test(value) || `${i18n.t('error.invalidDNI')}`,
        },
        // flag para resetear validaciones en los formularios
        resetForms: false,
        // copia de los ids de las ultimas empresas asignadas a la persona, para evitar traer una nueva lista anidada de cosas
        enterprisesCloned: []
    }),
    computed: {
        /**
         * Para deshabilitar el botón guardar
         */
        disableSaveBtn () {
            return !this.personDialogDataTab.validForm || !this.personDialogAddressTab.validForm || !this.personDialogContactTab.validForm || !this.personDialogCommentTab.validForm
                || (!this.personDialogDriverCodeTab.validForm || (this.personDialogDriverCodeTab.validForm && this.personDialogDriverCodeTab.model.driverCode != null
                    && !this.personDialogDriverCodeTab.model.reassignment && this.personDialogDriverCodeTab.model.personIdDriverCodeUnset != null) ||
                    !this.personDialogEnterpriseTab.model.enterpriseIds || this.personDialogEnterpriseTab.model.enterpriseIds.length < 1)
        }
    },
    created() {
    },
    beforeMount() {
        // push de los tabs
        this.tabs.push(this.personDialogDataTab)
        this.tabs.push(this.personDialogEnterpriseTab)
        this.tabs.push(this.personDialogAddressTab)
        this.tabs.push(this.personDialogContactTab)
        this.tabs.push(this.personDialogDriverCodeTab)
        this.tabs.push(this.personDialogCommentTab)
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            // tab de datos personales
            this.personDialogDataTab.model.firstName = null
            this.personDialogDataTab.model.lastName = null
            this.personDialogDataTab.model.dni = null
            this.personDialogDataTab.model.cuit = null
            this.personDialogDataTab.model.dateOfBirth = null
            this.personDialogDataTab.model.civilStatus = null
            //tab de empresas
            this.personDialogDataTab.model.enterpriseIds = []
            this.personDialogDataTab.model.enterprisesData = []
            this.personDialogDataTab.model.update = false
            // tab de domicilio
            this.personDialogAddressTab.model.address = null
            this.personDialogAddressTab.model.countryId = null
            this.personDialogAddressTab.model.provinceId = null
            this.personDialogAddressTab.model.cityId = null
            this.personDialogAddressTab.model.district = null
            this.personDialogAddressTab.model.zipCode = null
            // tab de contacto
            this.personDialogContactTab.model.phone1 = null
            this.personDialogContactTab.model.phone2 = null
            this.personDialogContactTab.model.whatsapp = null
            this.personDialogContactTab.model.sms = null
            this.personDialogContactTab.model.email1 = null
            this.personDialogContactTab.model.email2 = null
            // tab de comentario
            this.personDialogCommentTab.model.comment = null
            // tab de driver code
            this.personDialogDriverCodeTab.model._id = null
            this.personDialogDriverCodeTab.model.driverCode = null
            this.personDialogDriverCodeTab.model.personIdDriverCodeUnset = null
            this.personDialogDriverCodeTab.model.reassignment = false

            // para limpiar las validaciones en los formularios
            this.resetForms = true
            const that = this
            Vue.nextTick(function() {
                that.resetForms = false
            })
        },
        /**
         * Click fuera del dialog
         */
        clickOutside() {
            this.cancel()
        },
        /**
         * Cancelar
         */
        cancel() {
            this.pullBread(DialogPerson)
            this.resetFields()
        },
        /**
         * Guardar
         */
        save() {
            const personDto = this.getDto(this.model.update)
            if (this.model.update) {
                personService.update(personDto, this.personDialogDriverCodeTab.model.personIdDriverCodeUnset).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('person.successUpdateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitPerson')
                    this.cancel()
                })
            } else {
                personService.create(personDto, this.personDialogDriverCodeTab.model.personIdDriverCodeUnset).then(() => {
                    this.showSnackbar({
                        visible: true,
                        text: this.$t('person.successCreateMessage'),
                        timeout: 6000,
                        style: SnackbarStyle.SUCCESS
                    })
                    this.resetFields()
                    this.$emit('commitPerson')
                    this.cancel()
                })
            }
        },
        /**
         * Genera el DTO para actualizar / crear
         * @param {*} update
         */
        getDto(update = false) {
            const result = {
                firstName: this.personDialogDataTab.model.firstName,
                lastName: this.personDialogDataTab.model.lastName,
                cuit: this.convertCuitString(this.personDialogDataTab.model.cuit),
                dni: this.personDialogDataTab.model.dni,
                dateOfBirth: this.personDialogDataTab.model.dateOfBirth ? moment(this.personDialogDataTab.model.dateOfBirth).format('DD/MM/YYYY') : null,
                civilStatus: this.personDialogDataTab.model.civilStatus,
                enterpriseIds: this.personDialogEnterpriseTab.model.enterpriseIds,

                address: this.personDialogAddressTab.model.address,
                countryId: this.personDialogAddressTab.model.countryId,
                provinceId: this.personDialogAddressTab.model.provinceId,
                cityId: this.personDialogAddressTab.model.cityId,
                district: this.personDialogAddressTab.model.district,
                zipCode: this.personDialogAddressTab.model.zipCode,

                phone1: this.personDialogContactTab.model.phone1,
                phone2: this.personDialogContactTab.model.phone2,
                whatsapp: this.personDialogContactTab.model.whatsapp,
                sms: this.personDialogContactTab.model.sms,
                email1: this.personDialogContactTab.model.email1,
                email2: this.personDialogContactTab.model.email2,

                comment: this.personDialogCommentTab.model.comment,

                driverCode: this.personDialogDriverCodeTab.model.driverCode ? this.personDialogDriverCodeTab.model.driverCode : null,
            }
            if (update) {
                result._id = this.model._id
            }
            return result
        },
        /**
         * Elimina los guiones del string del cuit
         * @param {*} cuit
         */
        convertCuitString(cuit) {
            if (cuit) {
                const cuitSections = cuit.split('-')
                let result = ''
                cuitSections.forEach(section => { result += section })
                return result
            } else {
                return null
            }   
        }
    },
    watch: {
        model: {
            deep: true,
            immediate: true,
            handler: async function (newModel) {
                if (newModel) {
                    // datos personales
                    this.personDialogDataTab.model.firstName = newModel.firstName
                    this.personDialogDataTab.model.lastName = newModel.lastName
                    this.personDialogDataTab.model.cuit = newModel.cuit
                    this.personDialogDataTab.model.dni = newModel.dni
                    this.personDialogDataTab.model.dateOfBirth = newModel.dateOfBirth ? moment(newModel.dateOfBirth, 'DD/MM/YYYY').toDate().toISOString().substr(0, 10) : null
                    this.personDialogDataTab.model.civilStatus = newModel.civilStatus
                    
                    // empresas asignadas a la persona
                    this.personDialogEnterpriseTab.model.enterprisesData = await enterpriseService.getAllForSelectorUserABM(newModel.enterpriseIds)
                    this.personDialogEnterpriseTab.model.enterpriseIds.cleanAndUpdate(newModel.enterpriseIds)
                    this.enterprisesCloned = []
                    this.enterprisesCloned.cleanAndUpdate(newModel.enterpriseIds)

                    // domicilio
                    this.personDialogAddressTab.model.address = newModel.address
                    this.personDialogAddressTab.model.countryId = newModel.countryId
                    this.personDialogAddressTab.model.provinceId = newModel.provinceId
                    this.personDialogAddressTab.model.cityId = newModel.cityId
                    this.personDialogAddressTab.model.district = newModel.district
                    this.personDialogAddressTab.model.zipCode = newModel.zipCode

                    // contacto
                    this.personDialogContactTab.model.phone1 = newModel.phone1
                    this.personDialogContactTab.model.phone2 = newModel.phone2
                    this.personDialogContactTab.model.whatsapp = newModel.whatsapp
                    this.personDialogContactTab.model.sms = newModel.sms
                    this.personDialogContactTab.model.email1 = newModel.email1
                    this.personDialogContactTab.model.email2 = newModel.email2

                    // driver code
                    this.personDialogDriverCodeTab.model._id =  newModel._id
                    this.personDialogDriverCodeTab.model.driverCode =  newModel.driverCode
                    this.personDialogDriverCodeTab.model.reassignment =  false
                    this.personDialogDriverCodeTab.model.personIdDriverCodeUnset =  null

                    // comentario
                    this.personDialogCommentTab.model.comment = newModel.comment
                }
            }
        }
    }
}
